import React, { createRef, Component, KeyboardEventHandler } from 'react';
import styled from 'styled-components';

import { InputNumber } from 'antd';

interface TableNumberCellProps {
    type: 'decimal' | 'integer';
    isReadonly: boolean;
    value: number;
    minValue: number;
    maxValue: number;
    path?: string;
    onChange?: (path: string, value: number) => void;
}

const StyledInputNumber = styled(InputNumber)`
    width: 100% !important;
    margin-top: -6px !important;
    margin-bottom: -6px !important;

    .ant-input-number-input {
        text-align: right;
    }

    .ant-input-number-input:read-only {
        background: #f0f0f0;
    }

    .ant-input-number-handler-wrap {
        display: none;
    }
`;

export class TableNumberCell extends Component<TableNumberCellProps> {
    static defaultProps = {
        minValue: 0,
        maxValue: 1e14,
        isReadonly: false
    };

    readonly inputRef = createRef<InputNumber>();

    handleChange = (value?: number) => {
        const { path, minValue, maxValue, isReadonly, onChange } = this.props;
        if (!isReadonly && path !== undefined && onChange !== undefined && this.isNumeric(value)) {
            if (minValue <= value && value <= maxValue) {
                onChange(path, value);
            }
        }
    };

    handleKeyDown: KeyboardEventHandler<HTMLInputElement> = event => {
        const input = this.inputRef.current;
        if (event.key === 'Enter' && input !== null) {
            input.blur();
        }
    };

    isNumeric = (value: any): value is number => !isNaN(parseFloat(value)) && isFinite(value);

    formatter = (value: any) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    render() {
        const { inputRef, handleChange, handleKeyDown, formatter } = this;
        const { type, value, minValue, maxValue, isReadonly } = this.props;

        const precision = type === 'decimal' ? 2 : 0;
        const step = type === 'decimal' ? 0.01 : 1;

        return (
            <StyledInputNumber
                ref={inputRef}
                precision={precision}
                step={step}
                value={value}
                min={minValue}
                max={maxValue}
                readOnly={isReadonly}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                formatter={formatter}
            />
        );
    }
}
